import React from 'react'


export default function TextBox(props) {
    const errorStyle = {
        border: (props.errorBoolean) ? 'solid 2px #FD625E' : 'solid 2px #E4EBF3'
    }

    return (
        <div className="TextBox">
            <label className="TextBox--label" for={props.name}>{props.label}</label>
            <input
                className="TextBox--input"
                type="text"
                name={props.name}
                placeholder={props.placeholder}
                value={props.value}
                onChange={props.onChange}
                style={errorStyle}
            >

            </input>
            {(props.errorBoolean) && <h4 className="TextBox--error">{props.errorMessage}</h4>}
        </div>
    )
}